import request from '@/utils/request'
import { resolveApiBase } from '@/utils/apiBase'

export function listInvoicesByProject(projectId) {
  return request({
    url: `/api/invoice/by-project/${projectId}`,
    method: 'get'
  })
}

export function createInvoice(data) {
  return request({
    url: '/api/invoice',
    method: 'post',
    data
  })
}

export function uploadInvoiceFile(id, file) {
  const fd = new FormData()
  fd.append('file', file)
  return request({
    url: `/api/invoice/${id}/upload`,
    method: 'post',
    data: fd,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function downloadInvoiceUrl(id) {
  const base = resolveApiBase()
  return `${base}/api/invoice/${id}/download`
}

export function previewInvoiceUrl(id) {
  const base = resolveApiBase()
  return `${base}/api/invoice/${id}/preview`
}

export function getPublicInvoiceLink(id) {
  return request({
    url: `/api/invoice/${id}/public-link`,
    method: 'get'
  })
}
